import React, { useContext, useEffect} from "react";
// import styles from './GeneralAssets.module.css';
import styles from '../cookies/CookiesInternal.module.css';
import userStyles from '../../pages/users/Users.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { useNavigate } from "react-router-dom";
import TabNavigation from "../../tabNavigation/TabNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";
import HiQTabNavigation from "../../tabNavigation/HiQTabNavigation";

export default function HiQSchemeRequest(){

    const { linkObject , handleGetLinkObject } = useContext(LoggedInContext);
    const { brand,setBrand,country,setCountry,language,setLanguage,disable,setDisable,handlePageChange } = useContext(BrandCountryContext);

    useEffect(() => {
        setDisable(false);
        handlePageChange(window.location.pathname);
        handleGetLinkObject();
    },[]);

    const handleButtonClick = () => {
        window.open('https://form.jotform.com/Stratela/hiq-scheme-request-form','_blank');
    }


    return(
        <>
            <div className={styles.container}>
                <HiQTabNavigation selected={brand}/>
                <div className={styles.textContainer}>
                    <h4>Scheme Request</h4>
                    <br></br>
                    <p>
                    Your dedicated Goodyear Design team are here to help.<br/>
                    Here you can request a scheme and complete a submission form to get the project started.<br/>
                    Just click on the button or link below and it will take you to our Jotform submission page.<br/><br/>
                    From there, you will be guided through a short, step-by-step form allowing you to input the required project details.<br/>
                    This can be completed on either mobile or desktop devices.<br/>
Once completed your submission will be sent straight through to the design team and one of them will then shortly be in touch. <br/><br/>
                    Please note that site photos/videos will be required as part of your submission.<br/>
                    Diagrams are provided within the form to help guide you on how to correctly frame each image/video.
                    </p>
                    <br/>
                    <a href="https://form.jotform.com/Stratela/hiq-scheme-request-form" target="_blank" >https://form.jotform.com/Stratela/hiq-scheme-request-form</a>
                    <br/><br/>
                    <button className={`${userStyles.addButton} ${userStyles.hiq}`} onClick={handleButtonClick}>Open Form</button>
                </div>
            </div>
            <div className={styles.background} style={{backgroundPosition: '50% 30%', backgroundImage: 'url(./imgs/home/HiQ_Scheme_comp.jpg)'}}> </div>
         </>
    )
}